export default function ActivityBigIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="181"
      height="79"
      viewBox="0 0 181 79"
      fill="none"
    >
      <path
        d="M99.25 22V25.5H104.512C105.472 25.5 106.25 26.2787 106.25 27.2385V55.2616C106.25 56.2216 105.471 57 104.512 57H76.4885C75.5283 57 74.75 56.2214 74.75 55.2616V27.2385C74.75 26.2783 75.5287 25.5 76.4885 25.5H81.75V22H99.25ZM81.75 29H78.25V53.5H102.75V29H99.25V32.5H81.75V29ZM85.25 46.5V50H81.75V46.5H85.25ZM85.25 41.25V44.75H81.75V41.25H85.25ZM85.25 36V39.5H81.75V36H85.25ZM95.75 25.5H85.25V29H95.75V25.5Z"
        fill="#8E8E8E"
        fillOpacity="0.8"
      />
    </svg>
  );
}
